import { AttributesMixin, define, Store, type } from "@type-r/models";
import { getBuyersAsCommonParticipants, getSuppliersAsCommonParticipants } from "../../api/companyParticipant";
import { InvoicesFilters } from "./invoices-filters";
import { AssetType } from "../../api/assetType";
import { formatDateFilter } from "../../components/search-bar/filters/date-filter";

export interface InvoicesStore extends AttributesMixin<typeof InvoicesStore> { }
@define
export class InvoicesStore extends Store {
  static attributes = {
    filter: type(InvoicesFilters),
    isArchived: type(Boolean),
  }

  initialize() {
    this.filter.suppliers.set({
      selected: [],
      placeholder: 'Supplier Name',
      getItems: getSuppliersAsCommonParticipants
    })
    this.filter.buyers.set({
      selected: [],
      placeholder: 'Buyer Name',
      getItems: getBuyersAsCommonParticipants
    })
  }

  mapToQuery(skip: number = 0, count: number = 1000, stateId?: number) {
    const params: any = { skip: skip, count: count, assetTypeId: AssetType.invoice };

    if (this.filter.suppliers.selected && this.filter.suppliers.selected.length) {
      params.suppliers = this.filter.suppliers.selected;
      params.suppliers = params.suppliers.join('|');
    }
    else if (this.filter.buyers.selected && this.filter.buyers.selected.length) {
      params.buyers = this.filter.buyers.selected;
      params.buyers = params.buyers.join('|');
    }
    if (this.filter.invoiceNumber.value) {
      params.invoiceNumber = this.filter.invoiceNumber.value;
    }
    else if (this.filter.faceValue.value) {
      params.invoiceFaceValue = this.filter.faceValue.value;
    }
    else if (this.filter.invoiceDate.date) {
      params.invoiceDate = formatDateFilter(this.filter.invoiceDate.date);
    }
    else if (this.filter.invoiceDueDate.date) {
      params.invoiceDueDate = formatDateFilter(this.filter.invoiceDueDate.date);
    }
    else if (this.filter.effectiveDate.date) {
      params.effectiveDate = formatDateFilter(this.filter.effectiveDate.date);
    }
    else if (this.filter.filterAll && this.filter.filterAll.length > 2) {
      params.matchAll = this.filter.filterAll;
    }
    else if (this.filter.importJobId.value) {
      params.importJobId = this.filter.importJobId.value;
    }
    else if (this.filter.assetUid.value) {
      params.uid = this.filter.assetUid.value;
    }

    if (this.isArchived) {
      params.isArchived = this.isArchived;
    }

    if (stateId > 0) {
      params.stateId = stateId;
    }
    else if (this.filter.stateId > 0) {
      params.stateId = this.filter.stateId;
    }

    if (this.filter.sortBy) {
      params.sortBy = this.filter.sortBy.attr;
      params.sortDirection = this.filter.sortBy.asc ? 'asc' : 'desc';
    }
    return params;
  }
}  